

export class CommonTools {
  /**
   * This function checks if two objects have the same content.
   * It returns true if both objects are null or if all keys and values are identical.
   * It returns false if either object is null or if the objects have different keys or values.
   * @argument object1 : The first object to compare.
   * @argument object2 : The second object to compare.
   * @returns {boolean} : True if objects have the same content, false otherwise.
   */
  static haveSameContent<T>(object1: T, object2: T): boolean {



  /**
   * Recursively compares two objects to determine if they have identical keys and values.
   * Returns true if both objects are null or if they contain the same keys and values.
   * Returns false if either object is null, or if they have different keys or values.
   * Supports nested objects by recursively comparing each nested object.
   * @param objA - The first object to compare.
   * @param objB - The second object to compare.
   * @returns {boolean} - True if objects are identical in structure and content, false otherwise.
   */
    function compareObjects(objA: any, objB: any): boolean {
      if (objA == null && objB == null) {
        return true;
      }

      if (objA == null || objB == null) {
        return false;
      }

      const keysObjA = Object.keys(objA);
      const keysObjB = Object.keys(objB);

      if (keysObjA.length !== keysObjB.length) {
        return false;
      }

      for (const key of keysObjA) {
        if (!keysObjB.includes(key) || !compareObjects(objA[key], objB[key])) {
          return false;
        }
      }

      return true;
    }

    return compareObjects(object1, object2);
  }
  /**
  * This function finds an object by its 'id' in a list and removes it.
  * It does nothing if the object with the specified 'id' is not found.
  * @argument list : The list from which to remove the object.
  * @argument id : The 'id' of the object to remove.
  */
  static findAndSpliceById(list: any, id: any) {
    const index = list.findIndex(obj => obj.id === id);
    if (index > -1) list.splice(index, 1);
  }
  /**
  * This function creates a promise that resolves after a specified timeout.
  * It can be used to delay operations in an asynchronous manner.
  * @argument timeout : The amount of time in milliseconds to wait before resolving the promise.
  * @returns {Promise<void>} : A promise that resolves after the specified timeout.
  */
  static wait(timeout: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, timeout));
  }
  /**
  * This readonly property is a basic sorting callback function for strings.
  * It compares two strings in a case-insensitive manner and returns a value indicating their sort order.
  */
  static readonly BaseSortCb = (a: string, b: string) => {
    if (a.toLocaleLowerCase() < b.toLocaleLowerCase()) { return -1; }
    if (a.toLocaleLowerCase() > b.toLocaleLowerCase()) { return 1; }
    return 0;
  };
}

